import { gql } from "@apollo/client";

export const CREATE_INVOICE_UPLOAD_UNIT = gql`
  mutation createInvoiceUploadUnit($input: CreateInvoiceUploadUnitInput!) {
    documentHandler {
      createInvoiceUploadUnit(input: $input) {
        id
        success
      }
    }
  }
`;
